import ApiService from "@/common/api/api.service";

const AutenticacaoService = {
  logar(form) {
    return ApiService.post(`Autenticacao/autenticar-administrativo`, {
      ...form,
    });
  },
  validarToken() {
    return ApiService.get(`Autenticacao/token-valido`);
  },
  invalidarToken() {
    return ApiService.put(`Autenticacao/invalidar-token`);
  },
};

export default AutenticacaoService;
